<template>
  <div id="map" class="map" :style="{ height: height + 'px' }">
    <div class="google-map" ref="googleMap" :style="{ height: height + 'px' }"></div>
    <slot v-if="Boolean(google)" :google="google" :map="map" :bounds="bounds" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Loader } from "@googlemaps/js-api-loader";

export default defineComponent({
  name: "gMap",
  props: {
    mapConfig: Object,
    apiKey: String,
    height: { type: Number, default: 450 },
    markers: Array,
  },
  data() {
    return {
      google: null,
      map: null,
      bounds: null,
      mapConfigLocal: {},
    };
  },
  mounted() {
    const googleMapApi = new Loader({
      apiKey: this.apiKey,
      version: "weekly",
    });

    this.mapConfigLocal = JSON.parse(JSON.stringify(this.mapConfig));

    const myEle =
      document.getElementById("crentLocationMap") ||
      document.getElementById("crentLocationMapFull");
    if (myEle) {
      if (myEle.hasAttribute("data-zoom")) {
        this.mapConfigLocal.zoom = parseInt(myEle.dataset.zoom);
      }
      if (myEle.hasAttribute("data-mode")) {
        this.mapConfigLocal.mapTypeId = myEle.dataset.mode;
        // delete this.mapConfigLocal.styles;
      }
      if (myEle.hasAttribute("data-mapkey")) {
        if (myEle.dataset.mapkey !== "default") {
          this.mapConfigLocal.mapId = myEle.dataset.mapkey;
        } else {
          delete this.mapConfigLocal.styles;
        }
      }
      if (myEle.hasAttribute("data-maptypecontrol")) {
        // console.log("maptypecontrol", myEle.dataset.maptypecontrol);
        this.mapConfigLocal.mapTypeControl =
          myEle.dataset.maptypecontrol == "true" ? true : false;
      }
    }
    // console.log(this.mapConfigLocal);
    const mapContainer = this.$refs.googleMap;

    const head = document.getElementsByTagName("head")[0];

    // Save the original method
    const insertBefore = head.insertBefore;

    // Replace it!
    head.insertBefore = function (newElement, referenceElement) {
      if (
        newElement.href &&
        newElement.href.indexOf("//fonts.googleapis.com/css?family=Roboto") > -1
      ) {
        // console.info("Prevented Roboto from loading!");
        return;
      }
      if (
        newElement.href &&
        newElement.href.indexOf("//fonts.googleapis.com/css?family=Google+Sans+Text") > -1
      ) {
        // console.info("Prevented Google+Sans+Text from loading!");
        return;
      }

      insertBefore.call(head, newElement, referenceElement);
    };

    googleMapApi
      .load()
      .then(() => {
        this.google = window.google;
        this.map = new window.google.maps.Map(mapContainer, this.mapConfigLocal);
        this.bounds = new window.google.maps.LatLngBounds();
        // console.log(this.markers.length);
      })
      .then(() => {
        if (this.markers.length == 1) {
          setTimeout(() => {
            this.map.setZoom(this.mapConfigLocal.zoom);
          }, 250);
        }
      })
      .catch(() => {
        // do something
      });
  },
});
</script>
